















































































































































































































































































































































































































































































































import Vue from "vue";
import * as types from "../store/types";
import { mapGetters } from "vuex";

function parseNumber(value: string) {
  if (!value) return 0;

  const cleaned = value.replace(/[^0-9.]/g, "");
  if (!cleaned || Number.isNaN(cleaned)) return 0;

  return parseFloat(cleaned);
}

export default Vue.extend({
  name: "ApplicationReadOnly",

  props: {
    id: {
      type: Number,
      required: true,
    },
  },

  data: () => {
    return {
      printableFormValues: {},
      yesNoFields: [
        "ownRentSpace",

        "addressIsHome",
        "inGreeneCounty",
        "outsideGreeneCounty",

        "veteranOwned",
        "disability",
        "othersEmployed",

        "utilizationEconomic",
        "utilizationHealth",
        "complianceArpa",
        "complianceSinceStart",
        "complianceTaxCurrent",
        "complianceSuspended",
        "complianceLoanDelinquence",
      ],
    };
  },

  methods: {
    downloadFile(column: string) {
      location.href =
        process.env.VUE_APP_ARPA_API_URL +
        "/?route=get-attachment&applicationId=" +
        this.id +
        "&file=" +
        column;
    },
    setPrintableFormValues(values: Record<string, string | null>): void {
      this.printableFormValues = Object.keys(values)
        .map((key) => {
          const value = values[key];
          let printableValue = value;

          // yes nos
          if (this.yesNoFields.includes(key) && value !== null)
            printableValue = value ? "Yes" : "No";

          // empty
          if (!printableValue && !value) printableValue = "N/A";

          return { [key]: printableValue };
        })
        .reduce((acc, partialObj) => {
          return Object.assign({}, acc, partialObj);
        }, {});
    },
  },

  computed: {
    ...mapGetters({
      allFormValues: types.FORM_VALUES,
    }),

    // calc stuff

    spaceGrantTotal(): number {
      return this.allFormValues.ownRentSpace ? 5000 : 0;
    },
    fullTimeTotal(): number {
      return parseNumber(this.allFormValues.fullTimeCount) * 500;
    },
    partTimeTotal(): number {
      return parseNumber(this.allFormValues.partTimeCount) * 250;
    },
    maxAllowedTotal(): number {
      const total =
        5000 + this.spaceGrantTotal + this.fullTimeTotal + this.partTimeTotal;
      return total > 35000 ? 35000 : total;
    },

    totalAwardCalculation(): number {
      return Math.max(
        0,
        Math.min(this.maxAllowedTotal, this.totalNetEstImpact)
      );
    },

    estImpactToDate(): number {
      return (
        parseNumber(this.allFormValues.estLostProfit) +
        parseNumber(this.allFormValues.estIncreasedExpenditures)
      );
    },

    totalReliefToDate(): number {
      return (
        parseNumber(this.allFormValues.reliefSourcePpp) +
        parseNumber(this.allFormValues.reliefSourceSba) +
        parseNumber(this.allFormValues.reliefSourceCounty) +
        parseNumber(this.allFormValues.reliefSourceCity) +
        parseNumber(this.allFormValues.reliefSourceUnemployment) +
        parseNumber(this.allFormValues.reliefSourceOther)
      );
    },
    totalNetEstImpact(): number {
      return this.estImpactToDate - Math.max(0, this.totalReliefToDate);
    },
  },

  watch: {
    allFormValues: {
      immediate: true,
      handler(val) {
        console.log(val);
        this.setPrintableFormValues(val);
      },
    },
  },
});
